import React from 'react';
import { Col } from 'antd';
import { ReactComponent as ListIcon } from '../../../../../../../resource/forms/ListRectangular.svg';
import FormRow from '../../../../common/formComponents/FormRow/FormRow';
import styles from './AddressRow.module.scss';

const AddressRow = ({ address }) => {
  return (
    <FormRow>
      <Col span={24}>
        <p className={styles.addressRowLabel}>Адрес</p>
        <div className={styles.addressWrap}>
          <p className={styles.address}>{address}</p>
          <ListIcon className={styles.listIcon} />
        </div>
      </Col>
    </FormRow>
  );
};

export default AddressRow;
